/**
 * Debounce-задержка для запроса на обновление количества результатов
 * В миллисекундах
 */
export const TOTAL_COUNT_REQUEST_DEBOUNCE = 500;

export const DEFAULT_SORTING = 'rank';
